export default __webpack_public_path__ + "files/mississippi_river-33345300f05676641053148a7dd37020.png";